/** @type {import('../types').ProgramConfig} */
export default {
  code: 'ISFR',
  displayName: 'Innovation Sandbox Funding Request',
  shortName: 'ISFR',
  color: 'red',
  statusLabels: {
    recommend_approval: 'Recommend Approval',
    recommend_rejection: 'Recommend Rejection',
    needs_review: 'Needs Review',
  },
  sidebarItems: [],
  listColumns: [],

  feedback: {
    enabled: true,
    validations: [
      { key: 'stage_1_eligibility',
        label: '1. Eligibility Pre-Screen (SOP 1.1-1.15, 12 deterministic checks)',
        keywords: ['eligibility', 'stage_1', 'stage 1'] },
      { key: 'stage_2_financial',
        label: '2. Financial Validation (SOP 2.1-2.10, calculator + ARR)',
        keywords: ['financial', 'stage_2', 'stage 2'] },
      { key: 'stage_3_activity_design_win',
        label: '3. Activity Eligibility & Design Win (SOP 3.1-3.6)',
        keywords: ['activity', 'design win', 'stage_3', 'stage 3'] },
      { key: 'stage_4_account_verification',
        label: '4. Account Verification (SOP 4.1-4.11, AWS Account ID + history)',
        keywords: ['account', 'verification', 'stage_4', 'stage 4'] },
      { key: 'stage_5_scoring_recommendation',
        label: '5. Scoring & Recommendation (SOP 5.1-5.9)',
        keywords: ['scoring', 'recommendation', 'stage_5', 'stage 5'] },
    ],
    decisionOptions: [
      { value: 'recommend_approval',  label: 'Recommend Approval' },
      { value: 'recommend_rejection', label: 'Recommend Rejection' },
      { value: 'needs_review',        label: 'Needs Review' },
    ],
  },
};
